var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 289 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.311 58.73L277.99 68.1214L246.301 190.555H47.8394L13.0216 58.73H274.311Z",
    stroke: "currentColor",
    strokeWidth: 20.0577
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.566 58.6584L175.5 10.0289H255.39L274.342 58.6584H156.566Z",
    stroke: "currentColor",
    strokeWidth: 20.0577
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.783 158.292C121.642 158.292 128.761 141.535 121.305 128.469L105.344 100.289L88.275 128.469C79.8388 144.019 89.3401 158.292 104.783 158.292Z",
    stroke: "currentColor",
    strokeWidth: 20.0577,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrough);
export default __webpack_public_path__ + "static/media/trough.131fbb7bbca5b8111fc8d6e870237b42.svg";
export { ForwardRef as ReactComponent };